import { render } from "./ScoreGrid.vue?vue&type=template&id=5a5da331&scoped=true&ts=true"
import script from "./ScoreGrid.vue?vue&type=script&lang=ts"
export * from "./ScoreGrid.vue?vue&type=script&lang=ts"

import "./ScoreGrid.vue?vue&type=style&index=0&id=5a5da331&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5da331"]])

export default __exports__